import { useNavigate } from "react-router-dom";
import inConstructionImg from "../assets/inConstruction.webp";
import "./oakApp.css";

export default function OakApp() {
    const navigate = useNavigate();
    return (
        <>
            <title>Game Analysis | Oakmate</title>
            <meta
                name="description"
                content="Analyzing your chess game with the Oakmate review extension."
            />
            <div className="oakapp">
                <img
                    src={inConstructionImg}
                    alt="In Construction"
                    className="inConstructionImg"
                />
                <div className="inConstruction-title">
                    We're still cooking this up!
                </div>
                <div className="inConstruction-subtitle">
                    In the meantime, check out our Chrome extension — it works
                    right on chess.com.
                </div>
                <button
                    className="download-cta"
                    onClick={() => {
                        window.open(
                            "https://chromewebstore.google.com/detail/oakmate-game-review/fdledmdlgggnfddaeillbpahblnblbne",
                            "_blank",
                            "noopener,noreferrer"
                        );
                    }}
                >
                    <span className="download-cta-text">
                        Add To Chrome - It's free
                    </span>
                    <svg
                        width="24"
                        height="24"
                        fill="none"
                        viewBox="0 0 25 24"
                        className="download-cta-icon"
                    >
                        <g>
                            <path
                                fill="#E94737"
                                d="M12.405 1.969a9.935 9.935 0 0 0-9.936 9.936 9.935 9.935 0 0 0 9.936 9.936 9.935 9.935 0 0 0 9.936-9.936 9.935 9.935 0 0 0-9.936-9.936Z"
                            ></path>
                            <path
                                fill="#30A04C"
                                d="m3.697 16.693.198.346a9.927 9.927 0 0 0 8.51 4.802c.09 0 .18 0 .272-.002l-.158-.277L16.9 19.95V14.27H8.308l-4.37-7.568a9.89 9.89 0 0 0-1.47 5.202c0 1.737.446 3.369 1.229 4.788Z"
                            ></path>
                            <path
                                fill="#FBBC1C"
                                d="M21.158 7.2v-.028h-.014a9.307 9.307 0 0 0-.272-.47l-.272.47h-8.195v7.098h4.098l-4.37 7.57a9.937 9.937 0 0 0 8.876-4.968 9.918 9.918 0 0 0 .15-9.671Z"
                            ></path>
                            <path
                                fill="#E94737"
                                d="M21.01 6.937a9.931 9.931 0 0 0-8.434-4.968h-.357A9.87 9.87 0 0 0 7.438 3.3a9.88 9.88 0 0 0-3.504 3.406l.27.466h16.938a11.704 11.704 0 0 0-.132-.236Z"
                            ></path>
                            <path
                                fill="#FEFEFD"
                                d="M12.405 7.173a4.73 4.73 0 0 0-4.732 4.732 4.73 4.73 0 0 0 4.732 4.732 4.73 4.73 0 0 0 4.732-4.732 4.73 4.73 0 0 0-4.732-4.732Z"
                            ></path>
                            <path
                                fill="#3884F0"
                                d="M12.405 8.12a3.784 3.784 0 0 0-3.785 3.785 3.784 3.784 0 0 0 3.785 3.785 3.784 3.784 0 0 0 3.785-3.785 3.784 3.784 0 0 0-3.785-3.785Z"
                            ></path>
                        </g>
                    </svg>
                </button>
                <button className="back-to-home" onClick={() => navigate("/")}>
                    Back to home page
                </button>
            </div>
        </>
    );
}
